export { default } from './HeadlineAnimSplitLine';
